import React from 'react';
import CompExcelFilePassRemover from '../Components/CompExcelFilePassRemover';

function PageExcelFilePassRemover() {
    return (
        <div>
            <CompExcelFilePassRemover />
        </div>
    )
}

export default PageExcelFilePassRemover